import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LogsService } from '../../services/logs.service';
import { UserService } from '../../../services/user.service';

/**
 * Component for viewing workflow logging data.
 */
@Component({
	selector: 'workflow-logs',
	templateUrl: './logs.component.html',
	styleUrl: './logs.component.css'
})
export class LogsComponent implements OnInit {
	@Input() args: any;

	LOCALIZATION: any;

	logs: any[] = [];
	logsPagination = {
		page: 1,
		elementsPerPage: 10,
		elementsPerPageSizes: [10, 20, 50],
		sorting: {
			sort: 'eventDate,desc',
		},
		totalElements: 0,
		pageGap: 1,
		resultTotal: 0,
		pageChanged: (newPage: any) => {
			this.logsPagination.page = newPage;
			this.loadLogs(this.logsPagination.page);
		}
	};
	fetching: boolean = false;

	private isSortDirAsc: boolean = true;

	constructor(
		private logsService: LogsService,
		private userService: UserService,
		private modalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.loadLogs();
	}

	/**
	 * Fetches the worklfow log data.
	 */
	loadLogs(page?: number): void {
		this.fetching = true;
		if (page) {
			this.logsPagination.page = page;
		}
		let index = this.logsPagination.page - 1;
		this.logsService.getLogs(this.args.id, this.args.type, index, this.logsPagination, {}).then(
			(data: any) => {
				if (!data) {
					this.logs = [];
				} else {
					this.logs = data.content;
					this.logsPagination.page = data.page.number + 1;
					this.logsPagination.elementsPerPage = data.page.size;
					this.logsPagination.totalElements = data.page.totalElements;
					this.logsPagination.pageGap = 1 + (data.page.size * data.page.number);
					this.logsPagination.resultTotal = this.logs.length + (data.page.size * data.page.number);					
				}
				this.fetching = false;
			},
			() => {
				this.logs = [];
				this.fetching = false;
			}
		);
	}

	/**
	 * Downloads the logs data in various formats.
	 */
	downloadLogs(format: string): void {
		switch (format) {
			case "CSV":
				const content: string = this.logsService.formatLogsAsCSV(this.logs);
				const downloadName: string = `${this.args.subtitle}-${'logs'}.csv`;

				// Encode content as a Base64 data URL
				const base64Data: string = `data:text/csv;charset=utf-8,${encodeURIComponent(content)}`;
				const pom: HTMLAnchorElement = document.createElement('a');
				pom.href = base64Data;
				pom.setAttribute('download', downloadName);

				document.body.appendChild(pom);
				pom.click();

				setTimeout(() => {
					document.body.removeChild(pom);
				}, 100);
				break;

			default:
				console.warn(`Unsupported format: ${format}`);
				break;
		}
	}

	pageSizeChanged(size: number): void {
		this.logsPagination.elementsPerPage = size;
		this.loadLogs(1);
	}

	sortingChanged(sortby: string): void {
		this.isSortDirAsc = !this.isSortDirAsc;
		let direction = this.isSortDirAsc ? 'asc' : 'desc';
		this.logsPagination.sorting = { sort: sortby + ',' + direction };
		this.loadLogs(1);
	}
	
	/**
	 * Closes the modal.
	 */
	close(): void {
		this.modalService.dismiss();
	}
}
